import { actionCreators } from './AlertsState';
import { ApiEnums } from '../../Interfaces/ApiEnums';

export const resetAlertsState = async (dispatch: any) => {
  return dispatch(actionCreators.resetState());
};

export const setRefreshAlertsRequested = async (
  dispatch: any,
  refresh: boolean
) => {
  return dispatch(actionCreators.setRefreshAlertsRequested(refresh));
};

export const clearAllAlerts = async (dispatch: any) => {
  return dispatch(actionCreators.clearAllAlerts());
};

export const fetchAllAlerts = async (dispatch: any) => {
  return dispatch(actionCreators.fetchAllAlerts());
};

export const fetchAllNewAlerts = async (dispatch: any) => {
  return dispatch(actionCreators.fetchAllNewAlerts());
};

export const fetchAllAlertsByCommandStatus = async (
  dispatch: any,
  commandStatus: ApiEnums.CommandStatus
) => {
  return dispatch(actionCreators.fetchAllAlertsByStatus(commandStatus));
};

export const fetchAlertCounts = async (dispatch: any) => {
  return dispatch(actionCreators.fetchAlertCounts());
};

export const resetStartDateTimeFilter = async (dispatch: any) => {
  return dispatch(actionCreators.resetStartDateTimeFilter());
};

export const setStartDateTimeFilter = async (dispatch: any, date: Date) => {
  return dispatch(actionCreators.setStartDateTimeFilter(date));
};

export const resetEndDateTimeFilter = async (dispatch: any) => {
  return dispatch(actionCreators.resetEndDateTimeFilter());
};

export const setEndDateTimeFilter = async (dispatch: any, date: Date) => {
  return dispatch(actionCreators.setEndDateTimeFilter(date));
};

export const sendCommandResponse = async (
  dispatch: any,
  command: string,
  response: any
) => {
  return dispatch(actionCreators.sendCommandResponse(command, response));
};

export const useCurrentDateTime = async (dispatch: any, value: boolean) => {
  return dispatch(actionCreators.UseCurrentDateTime(value));
};
